import { Box, Grid, LinearProgress, Select, TextField, Typography } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { useState } from "react";
import { useReportSequenceDefinitionsAvailable } from "../../reportSequenceDefinitionQueries";
import { Field, FieldProps, Form, Formik } from "formik";
import RSDTemplate from "./RSDTemplate";



interface RSD {
    id: number;
    short_name: string;
}
const TSDExisting = () => {
    // const [value, setValue] = React.useState<string | null>("");
    // const names = ["9114 Mod1", "9114 Mod2", "9114 Mod3", "9114 Mod4", "9114 Mod5 and 6", "9114 Mod 7 and 8", "nevedos 9869 Mod1 & 2", "nevedos 9869 Mod 3 & 4", "nevedos 9869 Mod1 "];
    const [rsdValue, setRsd] = React.useState("")
    const [isSelected, setSelected] = React.useState(false);
    const [rsd_value, setRsdValue] = React.useState({});
    const {
        data: data,
        error: rsdError,
        isLoading: isLoadingRSD,
        isError: isErrorRSD,
    } = useReportSequenceDefinitionsAvailable();
    console.log('Data:', data);
    if (isLoadingRSD) {
        return <LinearProgress />;
    }
    function onRsdSelected(data: any): void {
        if (data) {
            setSelected(data ? true : false)
            setRsdValue(data)
            setRsd(data.id)
        }
    }

    const AutoCompleteField = ({ field, form, ...props }: FieldProps) => (
        <Autocomplete
            {...props}
            options={data && data}
            getOptionLabel={(option) => (option as RSD).short_name}
            onChange={(event, value) => onRsdSelected(value)}
            renderInput={(params) => <TextField {...params} label="RSD" fullWidth />}
        />
    );

    const AutoCompleteFieldSelected = ({ field, form, ...props }: FieldProps) => (
        <Autocomplete
            {...props}
            options={data && data}
            value={rsd_value}
            getOptionLabel={(option) => (option as RSD).short_name}
            onChange={(event, value) => onRsdSelected(value)}
            renderInput={(params) => <TextField {...params} label="RSD" fullWidth />}
        />
    );

    return (
        <div>

            <Box padding={2}>

                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item xs={4}>
                        <Typography variant="h5">Select Report Sequence Definitions</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        {/* <Autocomplete
                            value={value}
                            onChange={(event, newValue) => setValue(newValue)}
                            options={names}
                            renderInput={(params) => <TextField {...params} label="Select a name" />}
                        /> */}
                        <Formik
                            initialValues={{ tsd: '' }}
                            onSubmit={(values) => {
                                // handle form submission
                            }}
                        >
                            {() => (
                                <Form>
                                    <Field
                                        id="rsd"
                                        type="text"
                                        name="rsd"
                                        fullWidth
                                        component={isSelected ? AutoCompleteFieldSelected : AutoCompleteField}
                                        style={{ marginBottom: 32 }}
                                        label="RSD"
                                        data-testid="rsd"
                                    >

                                    </Field>
                                </Form>

                            )}
                        </Formik>


                    </Grid>
                </Grid>
            </Box>
            {rsdValue && <RSDTemplate tsdId={rsdValue}></RSDTemplate>}
        </div>
    )
}

export default TSDExisting;